<template>
  <div class="container">
    <v-img src="@/assets/login-bg.jpg" class="bg-img" />
    <div class="overlay"></div>
    <div class="login" data-aos="enter">
      <div class="login__header">
        <v-img src="@/assets/logo_white.png" class="login__header--logo" />
      </div>
      <div class="login__title">
        <h3>Your city, your way</h3>
      </div>
      <form name="authForm" class="login__content">
        <input
          v-if="create && !reset"
          name="name"
          type="text"
          placeholder="Name"
          v-model="name"
          :autofocus="'autofocus'"
          class="login__content--input"
          required
        />
        <input
          name="email"
          type="email"
          placeholder="Enter email"
          v-model="email"
          :autofocus="'autofocus'"
          class="login__content--input"
          required
        />
        <input
          v-if="!reset"
          name="password"
          type="password"
          placeholder="Enter password"
          v-model="password"
          @keyup.enter="login"
          class="login__content--input"
          required
        />
        <input
          v-if="create && !reset"
          name="confirm"
          type="password"
          placeholder="Confirm password"
          v-model="confirmPassword"
          @keyup.enter="login"
          class="login__content--input"
          required
        />

        <div v-if="!create && reset === false" class="login__content__remember">
          <span class="login__content__remember--remember-me">Remember me</span>
          <v-switch class="login__content__remember--switch" color="green"></v-switch>
        </div>
        <div class="login__content_btn-area">
          <button
            v-if="create"
            @click.prevent="newUser"
            class="login__content__btn-area--btn"
          >SIGN UP</button>
          <button
            v-if="!create && !reset"
            @click.prevent="signin()"
            class="login__content__btn-area--btn"
          >LOG IN</button>
          <button v-if="reset" @click.prevent="signin()" class="login__content__btn-area--btn">SEND</button>

          <button v-if="!reset" class="login__content__btn-area--facebook">
            <v-img class="facebook-logo" src="@/assets/facebook.png" />
          </button>
        </div>
        <span v-if="create === false" class="login__content__signup-msg">
          Don't have an account?
          <span
            class="login__content__signup-msg--link"
            @click="create = true"
          >SIGNUP</span>
        </span>
        <span v-if="create === true" class="login__content__signup-msg">
          Already a DSCVR member?
          <span
            class="login__content__signup-msg--link"
            @click="create = !create"
          >SIGNIN</span>
        </span>
        <a
          v-if="reset == false"
          class="login__content--reset"
          @click="reset = !reset"
        >Reset password</a>
        <a v-if="reset" class="login__content--reset" @click="reset = !reset">I know my password!</a>
      </form>
    </div>
    <v-alert class="login__content__alert" v-if="!error.success" type="error">
      <p class="login__content__alert--msg">{{error.message}}</p>
    </v-alert>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";

export default {
  name: "login",

  data() {
    return {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
      create: false,
      reset: false,
      error: {
        message: "",
        success: true
      }
    };
  },

  methods: {
    ...mapActions({
      login: "auth/login",
      signup: "auth/signup",
      clear: "auth/clear"
    }),

    newUser() {
      if (this.password != this.confirmPassword) {
        this.error.message = "Passwords do not match.";
        this.error.success = false;
      } else {
        this.signup({
          name: this.name,
          username: this.email,
          password: this.password
        });
      }
    },

    signin() {
      if (this.email == "" || this.password == "") {
        this.error.message = "Authentication failed.";
        this.error.success = false;
      } else {
        this.login({ username: this.email, password: this.password });
      }
    }
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    }),

    user() {
      return this.auth.user;
    },

    serverError() {
      return this.auth.error;
    }
  },

  watch: {
    reset: function(val) {
      if (val) {
        this.create = false;
      }
    },

    create: function(val) {
      if (val) {
        this.reset = false;
      }
    },

    serverError: function(val) {
      this.error.message = val;
      this.error.success = false;
    }
  },

  created() {
    const token = localStorage.getItem("token");
    if (token) {
      this.$router.push({ name: "home" });
    }
  },

  mounted() {
    this.clear();
    document.querySelector("body").style.position = "fixed";
  }
};
</script>

<style lang="sass" scoped>
@import @/styles/variables.sass
@import @/styles/mixins.sass
@import @/styles/base.sass

.container
  display: flex
  flex-flow: column
  align-items: center
  justify-content: center
  height: 100vh


  .bg-img
    position: absolute
    width: 100%

    @include for-size(phone-only)
      height: 100%

    @include for-size(tablet-portrait-up)
      height: 100%
  
.overlay
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 100%
  backdrop-filter: blur(3px)
  background: rgba($c-black, .3)

.login
  display: flex
  flex-flow: column
  justify-content: center
  width: 250px
  height: 400px
  border-radius: 5px
  z-index: 5
  background-image: linear-gradient(to bottom right, lighten($c-black, 15%), $c-black)
  box-shadow: -2px -1px 5px rgba(0, 0, 0, .5)

  &__header
    display: flex
    flex-flow: column
    justify-items: center
    height: 50px
    margin-bottom: 20px

    &--logo
      width: 30%
      margin: 20px auto

  &__title
    font-size: 14px
    padding-top: 10px
    margin: 5px auto 0 auto
    color: $c-white
    border-top: 1px solid black
  
  &__content
    width: 100%
    padding: 10px 40px
    display: flex
    flex-flow: column
    justify-content: center

    &--input[type="text"], &--input[type="email"], &--input[type="password"]
      height: 20px
      width: 150px
      background: darken($c-sirocco, 10%)
      margin: 5px
      color: $c-white
      text-indent: 5px
      font-size: 10px
      transition: background .3s

      &::placeholder
        color: lighten($c-gray, 20%)
        font-size: 10px

    &--input:focus
      background: $c-sirocco
      outline: none

    &--input[type="text"]
      &::placeholder
        color: lighten($c-gray, 20%)
        font-size: 10px
        position: relative
        background-image: url(../../assets/user.png)
        background-repeat: no-repeat
        background-size: 15px
        background-image: #fff
        background-position: 130px

    &--input[type="email"]
      &::placeholder
        color: lighten($c-gray, 20%)
        font-size: 10px
        position: relative
        background-image: url(../../assets/email.png)
        background-repeat: no-repeat
        background-size: 15px
        background-image: #fff
        background-position: 130px

    &__remember
      display: flex
      flex-flow: row
      justify-content: space-between
      margin-top: 10px
      padding: 0 5px
    
      &--remember-me
        font-size: 8px
        margin-top: 5px
        color: $c-white
      
      &--switch
        padding: 0
        margin: 0

    &__btn-area
      display: flex
      flex-flow: column

      &--btn
        width: 150px
        margin: 10px 10px
        padding: 5px
        border-radius: 30px
        background: $c-white
        font-size: 8px
        transition: all .3s
        outline: none

        &:hover   
          background: $dark-purple
          color: $c-white
          transform: scale(1.1)

      &--facebook
        position: relative
        left: 70px
        margin-top: 10px
        padding: 5px
        width: 30px
        background: $c-white
        border-radius: 50%
        transition: all .3s

        &:hover   
          background: #3B5998
          color: $c-white
          transform: scale(1.1)    


    &__signup-msg
      margin: 0 auto
      margin-top: 10px
      font-size: 10px
      color: $c-white 

      &--link
        text-decoration: underline
        &:hover
          cursor: pointer
    
    &--reset
      padding: 10px
      font-size: 10px
      margin: 0 auto
      color: $c-white

      &:hover
        text-decoration: underline

    &__alert
      height: 50px
      width: 250px
      margin: 5px
      border-radius: 0

      &--msg
        margin-top: 5px
        font-size: 8px

[data-aos="enter"]
  opacity: 0
  transform: scale(1.2)

  &.aos-animate
    opacity: 1
    transform: scale(1)

</style>
